import React from "react";

/**
 * Non-dismissible blocking overlay while tenant schema ensure runs on workspace enter.
 */
export default function WorkspaceUpdatingOverlay({ open }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-background/80 backdrop-blur-sm"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="workspace-updating-title"
      aria-busy="true"
    >
      <div className="mx-4 w-full max-w-sm rounded-xl border border-border bg-card p-6 shadow-lg">
        <h2
          id="workspace-updating-title"
          className="text-lg font-semibold tracking-tight text-foreground text-center"
        >
          Updating, please wait
        </h2>
        <p className="mt-2 text-sm text-muted-foreground text-center">
          Preparing this workspace. This usually only takes a moment.
        </p>
        <div
          className="mt-5 h-1.5 w-full overflow-hidden rounded-full bg-muted"
          aria-hidden="true"
        >
          <div className="workspace-updating-bar h-full w-1/3 rounded-full bg-primary" />
        </div>
        <style>{`
          @keyframes workspace-updating-slide {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(400%); }
          }
          .workspace-updating-bar {
            animation: workspace-updating-slide 1.2s ease-in-out infinite;
          }
        `}</style>
      </div>
    </div>
  );
}
